import { Label, Link } from "@fluentui/react";
import React from "react";
import { IProjectForm } from "../../forms/types/IProjectForm";
import { CForm } from "../../types";

export interface IGroupedDataGridItemProps {
  form: CForm;
}

const GroupedDataGridItem = (props: IGroupedDataGridItemProps): JSX.Element => {


  return <tr>

  </tr>

};





















export interface IGroupedDataGridProps {
  columns: IProjectForm[];
}

export const GroupedDataGrid = (props: IGroupedDataGridProps): JSX.Element => {

  const ROW_STYLE: React.CSSProperties = {
    border: "1px solid rgb(204, 204, 204)",
  };

  const onClick = () => {

  };

  const values = props.columns[ 0 ].form.values;
  console.log(values);

  return <table>
    <thead>
      <tr>
        {props.columns.map(x => <th style={ROW_STYLE}>
          <Label>{x.form.title}</Label>
        </th>)}
      </tr>
    </thead>
    <tbody>
      {props.columns.map((x, i) => <GroupedDataGridItem
        key={i}
        form={x.form}
      />)}
    </tbody>
    <tfoot>
      <tr>
        {props.columns.map(x => <th style={ROW_STYLE}>
          <Link onClick={onClick}>Add</Link>
        </th>)}
      </tr>
    </tfoot>
  </table>
};